<template>
    <div class="live-actionbar container">
        <div class="only-teacher">
            <van-checkbox class="checkbox" v-model="isOnlyTeacher" shape="square">只看老师和助教</van-checkbox>
        </div>
        <div class="right">
            <div v-if="showHandout" class="button" @click="clickHandout">讲义
                <svg class="svg" xmlns="http://www.w3.org/2000/svg" width="4" height="6" viewBox="0 0 4 6">
                    <g transform="translate(-552 -421)">
                        <rect width="4" height="6" transform="translate(552 421)" fill="#fff" opacity="0" />
                        <path d="M559.749,421.444l2,2-2,2" transform="translate(-6.749 0.556)" fill="none"
                            stroke="#13bf80" stroke-width="0.8" />
                    </g>
                </svg>
            </div>
            <!-- <div class="button" @click="clickSelections">选集 1 / 6
                <svg class="svg" xmlns="http://www.w3.org/2000/svg" width="4" height="6" viewBox="0 0 4 6">
                    <g transform="translate(-552 -421)">
                        <rect width="4" height="6" transform="translate(552 421)" fill="#fff" opacity="0" />
                        <path d="M559.749,421.444l2,2-2,2" transform="translate(-6.749 0.556)" fill="none" stroke="#13bf80"
                            stroke-width="0.8" />
                    </g>
                </svg>
            </div> -->
        </div>
    </div>
</template>
<script>
export default {
    props: {
        showHandout: false
    },
    data() {
        return {
            isOnlyTeacher: false,//是否只显示老师
        }
    },
    watch: {
        isOnlyTeacher(newValue) {
            this.$emit('onOnlyTeacher', newValue)
        }
    },
    methods: {
        clickHandout() {
            this.$emit('onHandout')
        },
        clickSelections() {
            this.$emit('selecTions')
        }
    }
}
</script>
<style lang="scss" scoped>
.live-actionbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(var(--main-rgba), .02);
    height: 1rem;
    border-bottom: 1px solid #EBECF0;

    .right {
        display: flex;
        align-items: center;
    }

    .only-teacher {
        display: flex;
        align-items: center;

        ::v-deep {
            .van-checkbox__icon {
                height: 0.32rem;

                &--checked {
                    .van-icon {
                        background-color: var(--main-color);
                    }
                }

                .van-icon {
                    width: 0.32rem;
                    height: 0.32rem;
                    line-height: .32rem;
                    font-size: .3rem;
                    border-color: var(--main-color);
                    border-radius: 0.05rem;
                }


            }

            .van-checkbox__label {
                margin-left: .11rem;
                color: #3C3D42;
                font-size: .32rem;
                line-height: inherit;
            }

        }
    }

    .button {
        @include flex_center;
        width: max-content;
        height: 0.48rem;
        border: 0.01rem solid rgba(var(--main-rgba), 0.5);
        padding: 0 .12rem;
        border-radius: 2px;
        color: var(--main-color);

        &+.button {
            margin-left: .3rem;
        }

        .svg {
            margin-left: 2px;

            path {
                stroke: var(--main-color);
            }
        }

    }
}
</style>